<template>
    <!--科別介紹 第四版 -->
    <v-layout row wrap xs12 sm12 md12 lg12 row--dense>

        <!--科別介紹-->
        <v-flex class="divHospBgStyle4 xs3 sm3 md3 lg2 mt-5 ml-5 mr-5 pl-3" style="max-width: 40%!important;"  >

            <div class="text-center" :style="{color:'white',textDecoration:'underline',fontSize:'1.5rem',textAlign:$vuetify.breakpoint.smAndDown?'center':'left'}" >
                {{showDivName(this.divNo).length==1?showDivName(this.divNo)[0].divName:''}}
                {{selfDiv=='ON'?this.divNo.value2:''}}
            </div>

            <div class="text-center s">
                <img
                        :src="divImage"
                        aspect-ratio="1"
                        class="lighten-2 imgShadow4 a"
                        width="300px;"
                        height="150px"
                        style="margin-bottom: 15px;margin-top: 10px;">
            </div>

            <div  v-if="selfDiv=='OFF'" style="margin-top: 250px!important;">
                <div cols="12" sm="12" md="12" style="width: 100%;padding: 3px" v-for="(item, i) in divNoList" :key="i" @click="changeDiv(item.divNo)"
                     class="divNoItem4 divNoBtnBg4 elevation-3 mt-4" >
                    {{item.divName}}
                </div>
            </div>

            <div  v-else style="margin-top: 80px!important;">
                <div cols="12" sm="12" md="12" style="width: 100%;padding: 3px" v-for="(item, i) in divNoList" :key="i" @click="changeSelfDiv(item)"
                     class="divNoItem4 divNoBtnBg4 elevation-3 mt-4" >
                    {{item.value2}}
                </div>
            </div>

        </v-flex>

        <!--科別介紹文字-->
        <v-flex class="xs6 sm6 md12 lg12  mt-5 "   :style="{maxWidth:$vuetify.breakpoint.smAndDown?'auto': '78%!important',marginTop:$vuetify.breakpoint.smAndDown?'210px!important':'auto'}" style="">


            <div :style="{whitespace:'white-space: pre-line',marginLeft:$vuetify.breakpoint.smAndDown?'auto':'130px!important'}" class="divHospDoc4 mt-2 ml-3" v-html="divDoc"></div>

            <v-row   class="xs12 sm12 md12 lg12 " :style="{marginTop:$vuetify.breakpoint.smAndDown?'':'250px'}">
                <v-progress-circular
                        rounded
                        height="6"
                        v-show="docLoading"
                        :size="50"
                        color="primary"
                        :indeterminate="docLoading"
                >載入中...</v-progress-circular>

                <v-col  cols="12" sm="12" md="6" lg="6" v-for="(item,index) in doctorList" :key="index" class="elevation-3 mx-1 my-1 doctor2">
                    <!--2021/10/18 改用元件化-->
                    <doctor-card-d :zone-name-list="zoneNameList" :item="item" :clinic-theme="clinicTheme"></doctor-card-d>

                </v-col>

            </v-row>

        </v-flex>


    </v-layout>
</template>

<script>
    import DoctorCardD from './DoctorCardD'
    export default {
        name: "DivD",
        components:{DoctorCardD},
        data() {
            return {
                zoneNameList:[],
                clinicTheme:'ClinicA',
                selfDiv:'OFF',
                divNo:'',
                divNoList:[],
                divLoading:false,
                divImage:'',
                divDoc:'',
                doctorList:[],
                docLoading:false,
                defaultIcon:'data:image/png;base64,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',
            }
        },
        created(){
            // this.axios_getDivNoList();
            this.axios_getRegCondSelfDiv();
            this.axios_getSysTheme();
            this.axios_getZoneNameALL();

        },
        watch: {
            '$route.params': function () {
                this.axios_getRegCondSelfDiv();
                this.axios_getSysTheme();
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let selfDiv = this.$route.params.selfDiv==undefined?'':this.$route.params.selfDiv;
                if(this.selfDiv=='OFF'){
                    this.divNo = divCode;
                    this.axios_getDivDocData('DIV',this.divNo);
                }else {
                    if(selfDiv==''){
                        this.axios_getDivDocData('SELFDIV',this.divNoList[0].value3);
                    }else {
                        this.axios_getDivDocData('SELFDIV',selfDiv);
                    }
                }
                this.axios_getDoctorListData(this.divNo);
            },
        },
        methods:{
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
            findSelfDivZone(divNo){
                return this.divNoList.filter((i) => {
                    return (i.value4==divNo) ;
                })
            },
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            selfDivItemText: item => item.value1==''?'':item.value1 + '-' + item.value2, //格式化 autocomplete 選權限顯示文字
            regDocClick(item){
                this.$router.push({name: this.clinicTheme, query: {empNo:item.empNo,zone:this.$route.query.zone}});
            },
            changeDiv(val){
                this.axios_getDivDocData('DIV',val);
                this.axios_getDoctorListData(val);
            },
            changeSelfDiv(val){
                this.divNo = val;
                this.axios_getDivDocData('SELFDIV',val.value1);
                this.axios_getDoctorListData(val.value3);
            },
            showDivName(divNo){
                return this.divNoList.filter((i) => {
                    return (i.divNo==divNo) ;
                })
            },
            findSelfDiv(divNo){
                return this.divNoList.filter((i) => {
                    return (i.value1==divNo) ;
                })
            },
            axios_getRegCondSelfDiv(){ //20210112  是否使用自訂義科別 查詢設定檔
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/REGCOND/SELF_DIV";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.selfDiv = response.data.resultSet[0].value1;
                        if(this.selfDiv=='ON'){
                            this.axios_getSelfDivAllData();
                        }else {
                            this.axios_getDivNoList();
                        }


                    }else{
                        this.selfDiv = 'OFF'
                        this.axios_getDivNoList();
                    }


                }).catch(error =>  {
                    try {
                        this.selfDiv = 'OFF'
                        console.log(error.response.data.status);

                    } catch(err) {
                        this.selfDiv = 'OFF'
                    }
                    this.axios_getDivNoList();

                });

            },
            axios_getSelfDivAllData (){ //查詢某院區全部自訂義科別
                this.divNoList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/SELFDIV/ALL";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divNoList = response.data.resultSet;
                        let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                        this.divNoList = this.findSelfDivZone(zone)
                        this.divNo = this.divNoList[0];
                        if(this.$route.params.divCode==undefined){
                            this.divNo = this.divNoList[0];
                            this.axios_getDivDocData("SELFDIV",this.divNo.value1);
                            this.axios_getDoctorListData(this.divNo.value3);
                        }else {
                            let divCode = this.$route.params.divCode==undefined?this.divNo.value3:this.$route.params.divCode;
                            let selfDiv = this.$route.params.selfDiv==undefined?this.divNo.value3:this.$route.params.selfDiv;
                            this.divNo = this.findSelfDiv(selfDiv)[0];
                            this.axios_getDivDocData("SELFDIV",selfDiv);
                            this.axios_getDoctorListData(divCode);
                        }
                    }
                }).catch(error =>  {

                    try {
                        console.log(error.response.data.status);
                        this.divNoList = [];
                    } catch(err) {
                        this.divNoList = [];
                    }
                });
            },
            axios_getDivNoList(){ //取得科別清單
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "division/datasearch/telandsubdiv/"+zone;

                this.$http.get(url).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.divNoList = response.data.resultSet;
                        if(this.$route.params.divCode==undefined){
                            this.divNo = this.divNoList[0].divNo;
                            let divCode = this.$route.params.divCode==undefined?this.divNo:this.$route.params.divCode;
                            this.divNo = divCode;
                            this.axios_getDivDocData("DIV",this.divNo);
                            this.axios_getDoctorListData(this.divNo);
                        }else {
                            let divCode = this.$route.params.divCode==undefined?this.divNo:this.$route.params.divCode;
                            this.divNo = divCode;
                            this.axios_getDivDocData("DIV",this.divNo);
                            this.axios_getDoctorListData(this.divNo);
                        }
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getDivDocData (docType,docCode){ //查詢科別醫院簡介

                this.divLoading = true;
                this.divImage = '';
                this.divDoc = '';

                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "hospdoc/datasearch/primarykeys/"+zone+"/"+docType+"/"+docCode;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.divImage = response.data.resultSet[0].docImage;
                        this.divDoc = response.data.resultSet[0].hospDoc;
                        this.divLoading = false;
                    }else{
                        this.divImage = '';
                        this.divDoc = '';
                        this.divLoading = false;
                    }


                }).catch(error =>  {
                    this.divLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.divImage = '';
                        this.divDoc = '';
                    } catch(err) {
                        this.divImage = '';
                        this.divDoc = '';
                    }


                });
            },
            //科別醫師簡介
            axios_getDoctorListData (divNo){ //查詢醫師簡介全部清單
                this.docLoading = true;
                this.doctorList = []
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let DIVNO = '';
                if(typeof divNo=='object'){
                    if(divNo.hasOwnProperty('value3')){
                        DIVNO = divNo.value3
                    }else {
                        DIVNO = divNo;
                    }
                }else{
                    DIVNO = divNo;
                }

                url = this.$store.state.AppSetting.backSrvUrl + "iregdoctor/datasearch/bydivno/"+zone+"/"+DIVNO;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;
                        this.docLoading = false;
                    }else{
                        this.doctorList = [];
                        this.docLoading = false;
                    }
                }).catch(error =>  {
                    this.docLoading = false;
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                });
            },
            //查詢樣式 1100113
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.clinicTheme = 'ClinicA';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicTheme = response.data.resultSet[0].value3;

                    }else{
                        this.clinicTheme = 'ClinicA';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicTheme = 'ClinicA';
                    } catch(err) {
                        this.clinicTheme = 'ClinicA';
                    }

                });


            },
        }
    }
</script>

<style scoped>

</style>